export default "__VITE_ASSET__jsOVJlEg__"